import { Status } from "src/core/constants/folders";
import { Roles } from "src/core/constants/roles";
import { useFolder, useFolderCurrentVersion } from "src/core/contexts/FolderContext";
import { usePermissions } from "src/core/hooks/usePermissions";

export const useFolderFooter = () => {
  const { folderFile, isModulationInProgress } = useFolder();
  const currentVersion = useFolderCurrentVersion();
  const { hasRole } = usePermissions();

  const folderState = folderFile.folderFile?.workflowStatus?.state?.code;
  const isDraft = folderState === Status.DRAFT;
  const isValidation =
    folderState === Status.VALIDATION_PENDING || folderState === Status.VALIDATION_PENDING_HR;
  const isValidated = folderState === Status.VALIDATED;
  const isRejected = folderState === Status.REJECTED;

  const isReexaminable =
    (isValidated || isRejected) && currentVersion.id === folderFile.folderFile?.id;

  const displayFooter = !hasRole(Roles.AUDITEUR);

  return {
    isDraft,
    isValidation,
    isValidated,
    isRejected,
    isReexaminable,
    displayFooter,
    isModulationInProgress,
  };
};
